var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[(_vm.$route.name!='Login')?_c('nav-bar',{attrs:{"route-name":_vm.routeName}}):_vm._e(),_vm._v(" "),_c('app-main'),_vm._v(" "),(_vm.footerMenuShow)?_c('footerMenu'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05fc5b47","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 